import type { FC } from 'react';

import { type ButtonProps, Button } from '@xing-com/button';
import { IconButterflyMono } from '@xing-com/icons';

const SignUpButton: FC<ButtonProps> = ({ to = '/start/signup', ...props }) => (
  <Button icon={IconButterflyMono} variant="primary" to={to} {...props} />
);

export { SignUpButton };
